import store from "../redux/store";
import { removeUser } from "../redux/slices/userSlice";

export const logOutUser = () => {
  localStorage.removeItem("accessToken");
  store.dispatch(removeUser());
};
